const SITE_TITLE = 'Invertebrate Brain Platform';
const SITE_SLOGAN = '';
// Replaces the Universal Analytics property (UA-2780881-1), shut down in 2023.
const GOOGLE_ANALYTICS_TRACKING_ID = 'G-JF4NM0XJHK';
const PICO_MODULES = ['documents', 'htmldocs'];

// Vite's BASE_URL always carries a trailing slash ('/' when the app is served
// from the document root). Strip it so it can be concatenated the same way
// CRA's PUBLIC_URL was.
const BASE_URL = import.meta.env.BASE_URL.replace(/\/$/, '');

export type MultiLang = 'en' | 'ja';

const Config = {
    SITE_TITLE,
    SITE_SLOGAN,
    GOOGLE_ANALYTICS_TRACKING_ID,
    PICO_MODULES,
    BASE_URL,
};

export default Config;
